import Head from "next/head";
import { motion } from "framer-motion";

export default function MapBackground() {
  return (
    <>
      <Head>
        <link
          rel="preload"
          as="image"
          href="/media/hero/partbot-hero-animation-mobile.jpg"
          media="(max-width: 768px)"
        />
        <link
          rel="preload"
          as="image"
          href="/media/hero/partbot-hero-animation.jpg"
          media="(min-width: 769px)"
        />
        <link
          rel="preload"
          as="video"
          href="/media/hero/partbot-hero-animation-mobile.mp4"
          type="video/mp4"
          media="(max-width: 768px)"
        />
        <link
          rel="preload"
          as="video"
          href="/media/hero/partbot-hero-animation.mp4"
          type="video/mp4"
          media="(min-width: 769px)"
        />
      </Head>
      <div className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-screen overflow-hidden">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.5 }}
          className="pointer-events-none absolute inset-0 -z-10 h-full w-full overflow-hidden"
        >
          <div className="inset-0 h-full w-full">
            <picture>
              <source
                media="(max-width: 768px)"
                srcSet="/media/hero/partbot-hero-animation-mobile.jpg"
              />
              <source srcSet="/media/hero/partbot-hero-animation.jpg" />
              <video
                className="absolute h-full w-full object-cover saturate-150"
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                poster="/media/hero/partbot-hero-animation.jpg"
              >
                <source
                  media="(max-width: 768px)"
                  src="/media/hero/partbot-hero-animation-mobile.mp4"
                  type="video/mp4"
                />
                <source
                  src="/media/hero/partbot-hero-animation.mp4"
                  type="video/mp4"
                />
              </video>
            </picture>
          </div>
          <div className="absolute top-0 h-screen w-full bg-linear-to-b from-emerald-950/5 via-emerald-950/25 to-stone-950"></div>
        </motion.div>
      </div>
    </>
  );
}
